import React, { useContext, useEffect, useState } from "react";
import { ScrollView, StyleSheet, Text, View } from "react-native";
import { useIsFocused } from "@react-navigation/native";
import { useSelector } from "react-redux";
import { MaterialCommunityIcons } from "@expo/vector-icons";

import useColorScheme from "../../hooks/useColorScheme";
import DeviceOrientationContext from "../../components/context/DeviceOrientationContext";
import { DataTableWithPagination } from "../../components/custom/DataTable/DataTableWithPagination2";
import { TouchableOpacity } from "react-native-gesture-handler";
import { headers, mdHeaders, smHeaders } from "./utils/operationHeaders";
import {
  mdNestedHeaders as ordersMdHeaders,
  nestedHeaders as ordersHeader,
  smNestedHeaders as ordersSmHeaders,
} from "./utils/nestedHeaders";

import { ordersCollectionModel } from "../../models/ordersModel";
import {
  getAllOperations,
  retrieveAllOperationUsers,
  retrieveRecentOrders,
  retrieveRecentUpdatedOrders,
} from "../../services/operationService";
import { OperationLabelBannerWithSearchTags } from "../../components/custom/Banners/OperationLabelBannerWithSearchTags";
import Spinner from "../../components/shared/Spinner";
import { OperationLabelBannerWithSearchBar } from "../../components/custom/Banners/OperationLabelBannerWithSearchBar";
import { Button } from "react-native-paper";
import { useToast } from "react-native-toast-notifications";
import OperationProcessingUserModal from "./partials/OperationProcessingUserModal";
import OperationStatusUpdateModal from "./partials/OperationStatusUpdateModal";

export default function OperationsManagementScreen({ route, navigation }: any) {
  const colorScheme = useColorScheme();
  const isFocused = useIsFocused();
  const [isRefresh, setRefresh] = useState<boolean>(false);
  const [isSearched, setIsSearched] = useState<boolean>(false);

  const [modalOpen, setModalOpen] = useState<boolean>();
  const [selectedEnquiryType, setSelectedEnquiryType] = useState<string>("");
  const onClose = () => {
    setModalOpen(false);
  };
  const [selectedItem, setSelectedItem] = useState<any>(null);

  const operationsFilterCategoryList = [
    "All",
    "Draft",
    "Pending",
    "Cancelled",
    "Processed",
    "Dispatched",
    "Completed",
    "Last 3 months",
  ];

  const { operationsList, isOperationsListLoaded } = useSelector(
    (state: any) => state.operations
  );

  const combinedOrders = operationsList.reduce((acc, item) => {
    if (item.orders && Array.isArray(item.orders)) {
      return acc.concat(item.orders);
    }
    return acc;
  }, []);

  const { isLargeDevice, isMediumDevice, isMobileDevice, isSmallDevice } =
    useContext(DeviceOrientationContext);

  const [_filterCategory, _setFilterCategory] = useState<string>("all");
  const [lastRefresh, setLastRefresh] = useState<string>("");
  const [_isDisplayViewOn, _setIsDisplayViewOn] = useState(false);
  const [tableHeaders, setTableHeaders] =
    useState<Record<string, Record<string, string | number | boolean>>>(
      headers
    );

  const [nestedTableHeaders, setNestedTableHeaders] =
    useState<Record<string, Record<string, string | number | boolean>>>(
      ordersHeader
    );
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const isUserAdmin = true;
  const columnsToNotHaveThousandsSeparator: Array<string> = [
    "Packing #",
    "Hubspot ID",
    "Document Number",
    "Customer Number",
    "SAP Document No",
  ];
  const [disableHeader, setDisableHeader] = useState<boolean>(false);

  const handleSearch = () => {
    return true;
  };
  const onHandleRowClick = () => {
    return true;
  };
  const [selected, setSelected] = useState<ordersCollectionModel>(
    {} as unknown as ordersCollectionModel
  );
  const onHandleDeleteRow = () => {
    return true;
  };
  const onHandleSortColumn = () => {
    return true;
  };

  const navigateToOrder = (order: any, action: string) => {
    if (action === "process_person" || action === "update_status") {
      setModalOpen(true);
      setSelectedItem(order);
      setSelectedEnquiryType(action);
    } else {
      navigation.navigate("SingleOperation", { order, action });
    }
  };

  useEffect(() => {
    const headersToUse = isLargeDevice
      ? headers
      : isMediumDevice
      ? mdHeaders
      : smHeaders;

    const nestedHeadersToUse = isLargeDevice
      ? ordersHeader
      : isMediumDevice
      ? ordersMdHeaders
      : ordersSmHeaders;

    setTableHeaders(headersToUse);
    setNestedTableHeaders(nestedHeadersToUse);
    setDisableHeader(isSmallDevice);

    if (isFocused || isRefresh) {
      getAllOperations(headersToUse);
      retrieveAllOperationUsers();
      setRefresh(false);
    }
  }, [isFocused, isRefresh, isLargeDevice, isMediumDevice, isSmallDevice]);

  const PageHeader = () => {
    if (isSmallDevice) return <SmPageHeader />;
    else return <DefaultPageHeader />;
  };

  const [loadingHubspot, setLoadingHubspot] = useState<boolean>(false);
  const toast = useToast();
  const handleRetrieveRecentOrders = async () => {
    setLoadingHubspot(true);
    await retrieveRecentOrders()
      .then(() => {
        getAllOperations(tableHeaders);
        setLoadingHubspot(false);
        toast.show("Orders has been queued for processing...", {
          type: "success",
        });
      })
      .catch((err) => {
        setLoadingHubspot(false);
        toast.show("Orders has been queued for processing...", {
          type: "success",
        });
      });
  };

  const handleRetrieveRecentUpdatedOrders = async () => {
    setLoadingHubspot(true);
    await retrieveRecentUpdatedOrders()
      .then(() => {
        getAllOperations(tableHeaders);
        setLoadingHubspot(false);
        toast.show("Updated Order has been queued for processing...", {
          type: "success",
        });
      })
      .catch((err) => {
        setLoadingHubspot(false);
        toast.show("Updated Order has been queued for processing...", {
          type: "success",
        });
      });
  };

  const SmPageHeader = () => {
    return (
      <>
        <View style={styles.drawerHeader}>
          <TouchableOpacity onPress={() => navigation.toggleDrawer()}>
            <Text>
              <MaterialCommunityIcons name="menu" size={24} color="black" />
            </Text>
          </TouchableOpacity>
          <View style={{ flex: 1, paddingLeft: 15 }}>
            <Text style={{ fontSize: 18, fontWeight: "500" }}>
              Order Status
            </Text>
          </View>
          <View
            style={{
              justifyContent: "center",
              borderBottomWidth: isSmallDevice || isMobileDevice ? 0 : 1,
              borderBottomColor: "#aeaeae",
            }}
          >
            <TouchableOpacity
              // onPress={() => navigation.navigate("ManageOperations")}
              onPress={() => navigation.navigate("PlaceOrder")}
            >
              <Text style={styles.newOrder}>
                New Order Request{" "}
                <MaterialCommunityIcons
                  name="plus-thick"
                  size={15}
                  color="#74BBFF"
                />{" "}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
        <View style={{ flex: 1 }}>
          <OperationLabelBannerWithSearchTags
            isMobileDevice={isMobileDevice}
            isSmallDevice={isSmallDevice}
            label="Quick Filter"
            noBorder={true}
            filterCategoryList={operationsFilterCategoryList}
            filterCategory={_filterCategory}
            setFilterCategory={_setFilterCategory}
            titleEnabled={true}
            tableHeaders={tableHeaders}
          />
        </View>

        <OperationLabelBannerWithSearchBar
          titleName={`Total Items: ${operationsList.length}`}
          setRefresh={setRefresh}
          dataToExport={combinedOrders}
          padding={true}
          fileName="orderReportScreen"
          sheetName="Order Report Screen"
        />
      </>
    );
  };

  const DefaultPageHeader = () => {
    return (
      <View style={styles.container}>
        {/* Header Section */}
        <View style={styles.drawerHeader}>
          <TouchableOpacity
            onPress={() => navigation.toggleDrawer()}
            style={styles.menuButton}
            hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
          >
            <MaterialCommunityIcons name="menu" size={24} color="#333" />
          </TouchableOpacity>

          <View style={styles.titleContainer}>
            <Text style={styles.titleText}>Order Status</Text>
          </View>
        </View>

        {/* Content Section */}
        <View style={styles.contentContainer}>
          {/* Filter Section */}
          <View style={styles.filterSection}>
            <OperationLabelBannerWithSearchTags
              isMobileDevice={isMobileDevice}
              isSmallDevice={isSmallDevice}
              label="Quick Filter"
              noBorder={true}
              filterCategoryList={operationsFilterCategoryList}
              filterCategory={_filterCategory}
              setFilterCategory={_setFilterCategory}
              titleEnabled={true}
              tableHeaders={tableHeaders}
            />
          </View>

          {/* Actions Section */}
          <View
            style={{
              flexDirection: "row",
              paddingHorizontal: 10,
              alignItems: "center",
              justifyContent: "space-between", // ensures left and right alignment
            }}
          >
            {/* Left side: Buttons */}
            <View
              style={[styles.buttonsWrapper, { flexDirection: "row", gap: 10 }]}
            >
              <Button
                mode="outlined"
                onPress={handleRetrieveRecentOrders}
                style={[styles.actionButton, styles.outlinedButton]}
                labelStyle={[styles.buttonLabel]}
                contentStyle={styles.buttonContent}
                disabled={loadingHubspot}
              >
                Recent Orders
              </Button>

              <Button
                mode="contained"
                onPress={handleRetrieveRecentUpdatedOrders}
                style={[styles.actionButton, styles.containedButton]}
                labelStyle={[styles.buttonLabel, styles.containedButtonLabel]}
                contentStyle={styles.buttonContent}
                disabled={loadingHubspot}
              >
                Update Orders
              </Button>
            </View>

            {/* Right side: Search bar */}
            <OperationLabelBannerWithSearchBar
              titleName={`Total Items: ${operationsList.length}`}
              setRefresh={setRefresh}
              dataToExport={combinedOrders}
              fileName="orderReportScreen"
              sheetName="Order Report Screen"
              disableTitle={true}
              noBorder={true}
            />
          </View>
        </View>
      </View>
    );
  };

  return (
    <>
      {modalOpen && selectedEnquiryType === "process_person" && (
        <OperationProcessingUserModal
          onClose={onClose}
          visible={modalOpen}
          order={selectedItem}
        />
      )}

      {modalOpen && selectedEnquiryType === "update_status" && (
        <OperationStatusUpdateModal
          onClose={onClose}
          visible={modalOpen}
          order={selectedItem}
        />
      )}

      <ScrollView style={{ flex: 1, backgroundColor: "#fff" }}>
        <PageHeader />
        {!isOperationsListLoaded || loadingHubspot ? (
          <View>
            <Spinner
              size="small"
              color="#74BBFF"
              styles={{
                flexDirection: "row",
                marginTop: "5%",
                marginBottom: "5%",
              }}
            />
          </View>
        ) : (
          <DataTableWithPagination
            headers={tableHeaders}
            nestedHeader={nestedTableHeaders}
            rows={operationsList}
            itemsPerPage={20}
            isDataLoading={isSearched}
            useModal={true}
            isRowsExpandable={true}
            setModalVisible={setModalVisible}
            handleRowClick={onHandleRowClick}
            setSelected={setSelected}
            isToExpandAllRows={_isDisplayViewOn}
            rowKeyValue="_id"
            nestedItemKeyValue="orders"
            isDetail={true}
            isEdit={isUserAdmin}
            isDelete={isUserAdmin}
            columnsToNotHaveThousandSeparator={
              columnsToNotHaveThousandsSeparator
            }
            handleDeleteRow={onHandleDeleteRow}
            handleSortColumn={onHandleSortColumn}
            operationsScreen={false}
            disableHeader={disableHeader}
            operationActions={navigateToOrder}
          />
        )}
      </ScrollView>
    </>
  );
}

const styles = StyleSheet.create({
  newOrder: {
    color: "#74BBFF",
    fontSize: 12,
  },
  modalButton: {
    borderRadius: 8,
    marginRight: 10,
    minWidth: 160,
    elevation: 2,
  },
  container: {
    backgroundColor: "#fff",
  },

  drawerHeader: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: "#e0e0e0",
    backgroundColor: "#fff",
    elevation: 2,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
  },

  menuButton: {
    padding: 8,
    borderRadius: 8,
    backgroundColor: "transparent",
  },

  titleContainer: {
    flex: 1,
    paddingLeft: 12,
  },

  titleText: {
    fontSize: 20,
    fontWeight: "600",
    letterSpacing: 0.5,
  },

  contentContainer: {
    borderBottomWidth: 1,
    borderBottomColor: "#e0e0e0",
  },

  filterSection: {
    paddingHorizontal: 16,
    paddingVertical: 12,
  },

  actionsContainer: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    minHeight: 60,
  },

  actionsContainerHorizontal: {
    flexDirection: "row",
    alignItems: "center",
  },

  buttonsWrapper: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 20,
    marginBottom: 12,
  },

  buttonsWrapperTablet: {
    gap: 16,
  },

  buttonsWrapperSmall: {
    flexWrap: "nowrap",
    marginRight: 16,
    marginBottom: 0,
  },

  actionButton: {
    borderRadius: 10,
    minWidth: 180,
    elevation: 3,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3,
  },

  actionButtonSmall: {
    minWidth: 160,
    marginRight: 12,
  },

  outlinedButton: {
    backgroundColor: "#f8f9fa",
    borderColor: "#007AFF",
    borderWidth: 1.5,
  },

  containedButton: {
    backgroundColor: "#007AFF",
  },

  buttonContent: {
    paddingHorizontal: 16,
    paddingVertical: 10,
    height: 44,
  },

  buttonLabel: {
    fontSize: 14,
    fontWeight: "500",
    textAlign: "center",
  },

  buttonLabelSmall: {
    fontSize: 13,
  },

  containedButtonLabel: {
    color: "white",
  },

  exportWrapper: {
    flex: 1,
    justifyContent: "center",
    minWidth: 200,
  },

  exportWrapperSmall: {
    minWidth: 180,
  },
});
